import React from "react";

const HomeShimmer = () => {
  return (
    <>
      <section className="font-poppins">
        <div className="bg-[#ffa194]/5">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 xl:py-14">
            <div className="flex flex-col md:flex-row justify-center md:justify-between gap-16">
              {/* Text & Owner Info Placeholder */}
              <div className="order-1 lg:order-2 flex flex-col gap-4 max-w-2xl pt-6">
                <div className="h-10 bg-gray-300 rounded w-3/4 animate-pulse"></div>
                <div className="h-4 bg-gray-300 rounded w-full animate-pulse"></div>
                <div className="h-4 bg-gray-300 rounded w-5/6 animate-pulse"></div>

                {/* Owner Info */}
                <div className="flex gap-5 mt-4">
                  <div className="w-12 h-12 rounded-full bg-gray-300 animate-pulse" />
                  <div className="flex flex-col gap-1 w-3/4">
                    <div className="h-4 bg-gray-300 rounded w-1/2 animate-pulse"></div>
                    <div className="flex gap-2 mt-1">
                      <div className="h-3 bg-gray-300 rounded w-1/3 animate-pulse"></div>
                      <div className="h-3 bg-gray-300 rounded w-1/4 animate-pulse"></div>
                    </div>
                  </div>
                </div>

                {/* Timing Cards */}
                <div className="mt-6 flex gap-4 md:gap-6 border border-[#FECDC1] rounded-2xl bg-white p-4 w-full md:w-96">
                  <div className="flex-1 space-y-2">
                    <div className="h-5 bg-gray-300 rounded w-1/2 animate-pulse"></div>
                    <div className="h-3 bg-gray-300 rounded w-full animate-pulse"></div>
                    <div className="h-3 bg-gray-300 rounded w-3/4 animate-pulse"></div>
                  </div>
                  <div className="w-px bg-[#FECDC1]" />
                  <div className="flex-1 space-y-2">
                    <div className="h-5 bg-gray-300 rounded w-1/2 animate-pulse"></div>
                    <div className="h-3 bg-gray-300 rounded w-full animate-pulse"></div>
                    <div className="h-3 bg-gray-300 rounded w-3/4 animate-pulse"></div>
                  </div>
                </div>
              </div>

              {/* Slider Placeholder */}
              <div className="order-2 lg:order-1 relative w-full p-4 max-w-[380px] h-[380px]">
                <div className="absolute inset-0 border-[20px] border-gray-300   animate-pulse" />
                <div className="absolute inset-0 rotate-6 border-[12px] border-gray-300   animate-pulse overflow-hidden" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeShimmer;
